function Footer(props) {
    return (
        <div className="footer">
            <h5>App Created by Zachary Pedigo</h5>
        </div>
    )
}

export default Footer